/* eslint-disable max-len */
import React from "react";
import {
  BaseForm,
  BaseFormInterface,
  BaseFormProps,
} from "components/common/forms/BaseForm";
import { BaseFormTitle } from "components/common/forms/BaseFormTitle";
import { BaseFormItem } from "components/common/forms/BaseFormItem";
import { BaseFormList } from "components/common/forms/BaseFormList";

export interface BaseButtonsFormProps extends BaseFormProps {
  footer?: React.ReactElement;
  loading?: boolean;
}

export const BaseButtonsForm: BaseFormInterface<BaseButtonsFormProps> = ({
  form,
  children,
  ...props
}) => {
  const [formDefault] = BaseForm.useForm();
  const currentForm = form || formDefault;

  return (
    <BaseForm form={currentForm} {...props}>
      {children}
    </BaseForm>
  );
};

BaseButtonsForm.Title = BaseFormTitle;
BaseButtonsForm.Item = BaseFormItem;
BaseButtonsForm.List = BaseFormList;
BaseButtonsForm.useForm = BaseForm.useForm;
BaseButtonsForm.Provider = BaseForm.Provider;
